import { render, staticRenderFns } from "./tabPage.vue?vue&type=template&id=605ebc38&scoped=true&"
import script from "./tabPage.vue?vue&type=script&lang=js&"
export * from "./tabPage.vue?vue&type=script&lang=js&"
import style0 from "./tabPage.vue?vue&type=style&index=0&id=605ebc38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "605ebc38",
  null
  
)

export default component.exports